// hooks/useMasterData.ts
import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";
import type { MasterScope } from "@/constants/masterScopes";
import logger from "@/utils/logger";

export interface MasterDataItem {
  id: number;
  optionName: string;
  optionValue: string;
  scope: string;
}

interface UseMasterDataOptions {
  size?: number;
}

export function useMasterData<T>(scope: MasterScope, options?: UseMasterDataOptions) {
  try {
    return useQuery<T[], Error>({
      queryKey: ["master-data", scope, options?.size ?? 100],
      queryFn: () => api.master.getMasterData<T>(scope, options?.size ?? 100),
      staleTime: 60 * 60 * 1000, // Fresh for 1 hour
      refetchOnWindowFocus: false,
      enabled: !!scope,
    });
  } catch (error) {
    logger.error(error);
    return {
      data: [],
      isLoading: false,
      isError: true,
    };
  }
}
